import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Button, Grid, Cell } from 'react-md'

import { DatePicker } from 'components'

const ExportSalesForm = ({ handleSubmit }) => (
  <Grid>
    <Cell desktopSize={6} size={12}>
      <Field
        id='from'
        name='from'
        label='From'
        component={DatePicker}
      />
    </Cell>
    <Cell desktopSize={6} size={12}>
      <Field
        id='to'
        name='to'
        label='To'
        component={DatePicker}
      />
    </Cell>
    <Cell size={12}>
      <Button
        flat
        primary
        swapTheming
        onClick={handleSubmit}
      >
        Download
      </Button>
    </Cell>
  </Grid>
)

export default reduxForm({
  form: 'export-sales'
})(ExportSalesForm)



// WEBPACK FOOTER //
// ./src/containers/ExportSales/ExportSalesForm.js